// extracted by mini-css-extract-plugin
export default {"confirmation":"Speech_confirmation__6326N","confirmationTitleError":"Speech_confirmationTitleError__-Af45"};